import React from 'react';
import GagDetailPanel from './GagDetailPanel';

/**
 * THE Breakdown's inline gag panel — a collapsible title bar over the full
 * `GagDetailPanel`. One component for the two charts that open a gag beside
 * themselves: the Timeline (under the chart) and Labour (under the clicked
 * person's row, 2026-10-14). Moved out of `pages/GagBreakdown.js` so the two
 * cannot drift (owner: "common code where possible").
 *
 * It owns NO state: the page owns which gag is open, the dirty flag and the
 * three-way prompt (`hooks/useDirtyPrompt.js`), and passes them through.
 * `title` is the page's freshest title for the gag (a rename inside the panel
 * refetches the list; the click-time snapshot would show the stale one).
 */
export default function GagInlinePanel({ title, onClose, className = '', ...panelProps }) {
  return (
    <div className={`bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl ${className}`.trim()}>
      {/* Clicking the header collapses the panel (the caller routes onClose
          through the same dirty guard as the ✕), and the whole bar gets a
          hover treatment so it reads as clickable. hover:bg-gray-100 is
          unprefixed on purpose: index.css's `html.dark .hover\:bg-gray-100:hover
          { … !important }` already gives it a working, non-inert dark-mode hover
          (#334155), so no separate dark:hover: class is needed — see
          CollapsibleCard.js's slate tint for the sibling pattern on a family
          that has no such override. */}
      <div className="flex items-center justify-between gap-2 px-4 py-3 bg-gray-50 dark:bg-gray-700/40 hover:bg-gray-100 rounded-t-xl border-b border-gray-200 dark:border-gray-700 transition-colors cursor-pointer">
        <button
          type="button"
          onClick={onClose}
          title="Collapse gag details"
          aria-label="Collapse gag details"
          data-testid="timeline-panel-collapse-header"
          className="flex-1 min-w-0 text-left text-sm font-bold text-gray-800 dark:text-gray-200 truncate"
        >
          {title}
        </button>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close gag details"
          className="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 font-bold px-2"
        >
          ✕
        </button>
      </div>
      <GagDetailPanel {...panelProps} />
    </div>
  );
}
